import React from 'react';

const TextArea = ({ label, value, onChange, rows, placeholder }) => (
    <div>
        <p className='text-xl text-start mb-3 mt-3'>{label}</p>
        <textarea
            onChange={onChange}
            value={value}
            className="py-3 px-2 block w-full border-b-2 border-gray-200 text-sm focus:border-blue-500  focus:border-b-blue-500 focus:ring-0 disabled:opacity-50 disabled:pointer-events-none dark:border-b-gray-700 dark:text-gray-400 dark:focus:ring-gray-600 dark:focus:border-b-gray-600"
            rows={rows}
            placeholder={placeholder}
        />
    </div>
);

export default TextArea;
